import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { Button, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import InputBase from "@mui/material/InputBase";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import WelcomeNameContainer from "../../LaunchComponent/WelcomeNameContainer";
import { fetchCampaignsData, handleCampainIDSelection, resetSubmissionButton } from "../../Redux/Mailer";
import { fetchNonCampignMails, handleFetchProgramNames, handleGenerateVivaRecognition, handleGenerateVivaRecognitionNewContent, handleVivaLoadingRecognition } from "../../Redux/Viva";
import VivaDisplayPage from "./vivaDisplayPage";
import "./RecognitionMailForm.css";
const WhiteBorderTextField = styled(TextField)(({
  theme
}) => ({
  " & label.Mui-focused": {
    color: " #a804ff"
  },
  " & .MuiOutlinedInput-root": {
    padding: "8.5px 12px  !important",
    "&.Mui-focused fieldset": {
      borderColor: "#a814ff",
      borderWidth: "1px"
    }
  },
  "& .MuiInputBase-input": {
    // Use the system font instead of the default Roboto font.
    fontFamily: ["Graphik-Regular"],
    fontSize: "14px"
  },
  "& .MuiInputBase-root-MuiOutlinedInput-root": {
    padding: "1px 2px !important"
  }
}));
const CustomRadio = styled(Radio)(({
  theme
}) => ({
  "&.Mui-checked": {
    color: "#9c27b0" // Purple for the checked state
  },
  "& .MuiSvgIcon-root": {
    fontSize: "1.5rem" // Custom icon size
  },
  "&:hover": {
    backgroundColor: "rgba(156, 39, 176, 0.08)" // Optional hover effect
  }
}));
const BootstrapInput = styled(InputBase)(({
  theme
}) => ({
  "label + &": {
    marginTop: theme.spacing(3)
  },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 14,
    padding: "9px 26px 9px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: ["Graphik-Regular"]
  }
}));
const RecognitionMailForm = ({
  campaigns,
  mailerChild,
  setMailerChild,
  setMailerParent,
  mailerParent
}) => {
  const HtmlTooltip = styled(({
    className,
    ...props
  }) => <Tooltip {...props} classes={{
    popper: className
  }} />)(({
    theme
  }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#f5f5f9",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: "1px solid #dadde9"
    }
  }));
  const [programNameViva, setprogramNameViva] = useState("");
  const [campaign, setCampaign] = useState(0);
  const [programName, setProgramName] = useState("");
  const [uniqueID, setUniqueID] = useState("");
  const [contentCategory, setContentCategory] = useState("");
  const [programDateViva, setProgramDateViva] = useState(null);
  const [isMailGeneratedVivaLaunch, setIsMailGeneratedVivaLaunch] = useState("");
  const [keyMessageViva, setKeyMessageViva] = useState("");
  const [mailerStatus, setMailerStatus] = useState("");
  const campaignList = useSelector(state => state.model.campaignList);
  const options = campaignList.message !== "No campaign for this user." && campaignList.length > 0 ? campaignList.map(item => ({
    id: item.id,
    name: item.name
  })) : [];
  const programDetails = useSelector(state => state.viva.programDetails);
  const programOptions = programDetails.length > 0 ? programDetails.map(item => ({
    programname: item.programname,
    uniqueID: item.uniqueID,
    category: item.category
  })) : [];
  const [isVivaLaunchMailGenerationClicked, setIsVivaLaunchGenerationClicked] = React.useState(false);
  const [isVivaNavigatedToForm, setIsVivaNavigatedToForm] = useState(false);
  const handleRadioChange = e => {
    setCategoryName(e.target.value);
    // let val = "Recognition";
    // dispatch(handleFetchProgramNames(val, e.target.value));

    dispatch(fetchCampaignsData(e.target.value));
    setValue("");
    handleRadioChangeReset();
  };
  const isMailLoaded = useSelector(state => state.viva.isVivaLoadedRecognition);
  const mailData = useSelector(state => state.viva.mailDataRecognition);
  const [categoryName, setCategoryName] = useState("program");
  const dispatch = useDispatch();
  const handleContentCategory = event => {
    setContentCategory(event.target.value);
    setIsMailGeneratedVivaLaunch("init");
  };
  const handleVivaMailGeneration = () => {
    setIsVivaLaunchGenerationClicked(true);
    if (mailerStatus == "yes") {
      let values = {
        programNameViva: programName,
        uniqueID: uniqueID,
        contentCategory: contentCategory,
        currentContent: "",
        sessionID: localStorage.getItem("sessionId")
      };
      dispatch(handleGenerateVivaRecognition(values));
    } else {
      let values = {
        programNameViva: programNameViva,
        uniqueID: uniqueID,
        contentCategory: contentCategory,
        currentContent: "",
        sessionID: localStorage.getItem("sessionId"),
        launchDate: programDateViva,
        keyMessage: keyMessageViva,
        categoryName: categoryName,
        userquery: ""
      };
      dispatch(handleGenerateVivaRecognitionNewContent(values));
    }
  };
  const handleReset = () => {
    dispatch(resetSubmissionButton());
    setMailerChild("");
    setMailerParent("");
    setCategoryName("program");
    setProgramDateViva("");
    setContentCategory("");
    setKeyMessageViva();
    setprogramNameViva("");
  };
  const handleCampaignID = value => {
    if (value) {
      setCampaign(value.id);
      let campaignID = value.id;
      dispatch(handleCampainIDSelection(campaignID));
      let val = "Recognition";
      dispatch(handleFetchProgramNames(campaignID, val));
    }
  };
  useEffect(() => {
    dispatch(fetchCampaignsData(categoryName));
  }, []);
  const handleProgramName = value => {
    if (value) {
      setProgramName(value.programname);
      let selected = programDetails.filter(item => item.programname == value.programname);
      setUniqueID(selected[0].uniqueID);
      setIsMailGeneratedVivaLaunch("init");
    }
  };
  const [value, setValue] = React.useState(null);
  const handleChange = event => {
    if (event.target.value == "no") {
      setCampaign(0);
      dispatch(handleCampainIDSelection(0));
    }
    handleRadioChangeReset();
    setValue(event.target.value);
  };
  const handleChangeMailerStatus = event => {
    setMailerStatus(event.target.value);
    setContentCategory("");
    setProgramName("");
    setKeyMessageViva("");
    setprogramNameViva("");
    if (event.target.value == "no" && value == "yes") {
      let data = campaignList.filter(val => val.id == campaign);
      setprogramNameViva(data[0].name);
    }
    if (event.target.value == "yes" && value == "no") {
      dispatch(fetchNonCampignMails("Recognition", categoryName));
    }
  };
  const handleRadioChangeReset = () => {
    setProgramDateViva("");
    setProgramName("");
    setMailerStatus("");
    setContentCategory("");
    setKeyMessageViva();
    setprogramNameViva("");
    dispatch(resetSubmissionButton());
    setIsMailGeneratedVivaLaunch("init");
    setIsVivaNavigatedToForm(false);
  };
  return <>
   {!isVivaLaunchMailGenerationClicked ? <Stack sx={{
      width: "100%"
    }} spacing={10}>
     <Stack sx={{
        height: "20px"
      }}>
      <WelcomeNameContainer currentComp="Viva-Engage-Recognition" />
     </Stack>
     <Stack spacing={4} sx={{
        paddingLeft: "30px",
        marginTop: "60px !important"
      }}>
      <div className="mailer-form-categories-section">
       <label class="mailer-form-categories-container">
        <span className="mailer-form-categories-text">Learning Program</span>
        <input type="radio" checked={categoryName === "program"} value="program" name="radio-category" onChange={handleRadioChange} />
        <span class="mailer-form-categories-checkmark"></span>
       </label>
       <label class="mailer-form-categories-container">
        <span className="mailer-form-categories-text">Event</span>
        <input type="radio" checked={categoryName === "event"} value="event" name="radio-category" onChange={handleRadioChange} />
        <span class="mailer-form-categories-checkmark"></span>
       </label>
       <label class="mailer-form-categories-container">
        <span className="mailer-form-categories-text">Microsite/Tool/Platform</span>
        <input type="radio" checked={categoryName === "Microsite/Tool/Platform"} value="Microsite/Tool/Platform" name="radio-category" onChange={handleRadioChange} />
        <span class="mailer-form-categories-checkmark"></span>
       </label>

       <label class="mailer-form-categories-container">
        <span className="mailer-form-categories-text">Webinar</span>
        <input type="radio" checked={categoryName === "webinars"} value="webinars" name="radio-category" onChange={handleRadioChange} />
        <span class="mailer-form-categories-checkmark"></span>
       </label>
      </div>
      <Stack direction={"column"} sx={{
          alignItems: "flex-start"
        }} spacing={2}>
       <Stack direction={"row"} sx={{
            alignItems: "flex-start"
          }} spacing={2}>
        <Stack direction={"column"}>
         <Typography>
          Is this communication part of any campaign?
          <span className="migrated-style-recognitionmailform-f75452-1">*</span>
         </Typography>
         <Typography>(If yes, select the campaign name)</Typography>
        </Stack>

        <FormControl>
         <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group" value={value} onChange={handleChange} sx={{
                paddingLeft: "20px"
              }}>
          <FormControlLabel value="yes" control={<CustomRadio icon={<RadioButtonUncheckedIcon className="migrated-style-recognitionmailform-f75452-2" />} // Empty circle when unchecked
                checkedIcon={<CheckCircleOutlineIcon className="migrated-style-recognitionmailform-f75452-3" />} // Checkmark inside circle when checked
                />} label="Yes" />
          <FormControlLabel value="no" control={<CustomRadio icon={<RadioButtonUncheckedIcon className="migrated-style-recognitionmailform-f75452-4" />} // Empty circle when unchecked
                checkedIcon={<CheckCircleOutlineIcon className="migrated-style-recognitionmailform-f75452-5" />} // Checkmark inside circle when checked
                />} label="No" />
         </RadioGroup>
        </FormControl>
       </Stack>
       {value == "yes" && <Stack direction={"row"} sx={{
            alignItems: "center"
          }} spacing={2}>
         <Typography>
          Select the campaign <span className="migrated-style-recognitionmailform-f75452-6">*</span>
         </Typography>
         <Stack sx={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              marginBottom: "10px",
              m: 1,
              width: "300px",
              mt: 3
            }} direction={"row"} spacing={2}>
          {/* <Select input={<BootstrapInput />} value={campaign} onChange={handleCampaignID}>
           {campaignList.message != "No campaign for this user." &&
            campaignList.length > 0 &&
            campaignList.map((item, index) => (
             <MenuItem key={index + 1} value={item.id}>
              {item.name}
             </MenuItem>
            ))}
           </Select> */}
          <Autocomplete value={options.find(option => option.id === campaign) || null} onChange={(event, newValue) => {
                handleCampaignID(newValue);
              }} options={options} getOptionLabel={option => option.name || ""} ListboxProps={{
                style: {
                  maxHeight: "150px",
                  // Fixed height for the dropdown
                  overflowY: "auto" // Enable vertical scrolling
                }
              }} renderInput={params => <TextField sx={{
                "& .MuiOutlinedInput-root": {
                  padding: "2px !important"
                }
              }} {...params} variant="outlined" />} filterSelectedOptions={false} />
         </Stack>
        </Stack>}
      </Stack>
      <Stack direction={"column"} sx={{
          alignItems: "flex-start"
        }} spacing={2}>
       <Stack direction={"row"} sx={{
            alignItems: "flex-start"
          }} spacing={2}>
        <Stack direction={"column"}>
         <Typography>
          Is this part of a Mailer?
          <span className="migrated-style-recognitionmailform-f75452-7">*</span>
         </Typography>
         <Typography>(If yes, select the program name)</Typography>
        </Stack>

        <FormControl>
         <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group" value={mailerStatus} onChange={handleChangeMailerStatus} sx={{
                paddingLeft: "20px"
              }}>
          <FormControlLabel value="yes" control={<CustomRadio icon={<RadioButtonUncheckedIcon className="migrated-style-recognitionmailform-f75452-8" />} // Empty circle when unchecked
                checkedIcon={<CheckCircleOutlineIcon className="migrated-style-recognitionmailform-f75452-9" />} // Checkmark inside circle when checked
                disabled={value == null || value == "yes" && campaign == 0 ? true : false} />} label="Yes" />
          <FormControlLabel value="no" control={<CustomRadio icon={<RadioButtonUncheckedIcon className="migrated-style-recognitionmailform-f75452-10" />} // Empty circle when unchecked
                checkedIcon={<CheckCircleOutlineIcon className="migrated-style-recognitionmailform-f75452-11" />} // Checkmark inside circle when checked
                disabled={value == null || value == "yes" && campaign == 0 ? true : false} />} label="No" />
         </RadioGroup>
        </FormControl>
       </Stack>
       {mailerStatus == "yes" && <Stack direction={"row"} spacing={2}>
         {" "}
         <Stack direction={"row"} sx={{
              alignItems: "end"
            }} spacing={2}>
          <Typography>
           Select the program name <span className="migrated-style-recognitionmailform-f75452-12">*</span>
          </Typography>
          <Stack sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginBottom: "10px",
                m: 1,
                width: "300px",
                mt: 3
              }} direction={"row"} spacing={2}>
           {/* <Select
            input={<BootstrapInput />}
            value={programName}
            onChange={handleProgramName}
            >
            {programDetails.length > 0 &&
             programDetails.map((item, index) => (
              <MenuItem key={index + 1} value={item.programname}>
               {item.programname}
              </MenuItem>
             ))}
            </Select> */}
           <Autocomplete value={programOptions.find(option => option.programname === programName) || null} onChange={(event, newValue) => {
                  handleProgramName(newValue);
                }} options={programOptions} getOptionLabel={option => option.programname || ""} ListboxProps={{
                  style: {
                    maxHeight: "150px",
                    // Fixed height for the dropdown
                    overflowY: "auto" // Enable vertical scrolling
                  }
                }} renderInput={params => <TextField sx={{
                  "& .MuiOutlinedInput-root": {
                    padding: "2px !important"
                  }
                }} {...params} variant="outlined" />} filterSelectedOptions={false} />
          </Stack>
         </Stack>
         <Stack spacing={0.5}>
          <Stack direction={"row"} justifyContent={"space-between"}>
           <Typography sx={{
                  fontSize: "14px",
                  fontFamily: "Graphik-Medium"
                }}>
            Category<span className="migrated-style-recognitionmailform-f75452-13">*</span>
           </Typography>
           <HtmlTooltip arrow title={<React.Fragment>Select the content category </React.Fragment>}>
            <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-recognitionmailform-f75452-14"></img>
           </HtmlTooltip>
          </Stack>
          <Stack sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginBottom: "10px",
                m: 1,
                width: "300px",
                mt: 3
              }} direction={"row"} spacing={2}>
           <Select input={<BootstrapInput />} value={contentCategory} onChange={handleContentCategory}
                // MenuProps={MenuProps}
                disabled={mailerStatus == null || mailerStatus == "yes" && programName == "" ? true : false}>
            <MenuItem key={0} value={1}>
             Post content/Caption
            </MenuItem>
            <MenuItem key={1} value={2}>
             Creative content/Image copy
            </MenuItem>
            <MenuItem key={2} value={3}>
             All of the above
            </MenuItem>
           </Select>
          </Stack>
         </Stack>
        </Stack>}
      </Stack>
      {mailerStatus == "no" ? <Stack direction={"column"} spacing={2} alignItems={"center"}>
        <Grid container spacing={2}>
         <Grid item xs={3}>
          <Stack spacing={0.5}>
           <Stack direction={"row"} justifyContent={"space-between"}>
            <Typography sx={{
                    fontSize: "14px",
                    fontFamily: "Graphik-Medium"
                  }}>
             Name<span className="migrated-style-recognitionmailform-f75452-15">*</span>
            </Typography>
            <HtmlTooltip arrow title={<React.Fragment>
               {" "}
               {categoryName == "program" ? <p> Enter the program name </p> : categoryName == "event" ? <p> Enter the event name</p> : categoryName == "Microsite/Tool/Platform" ? <p> Enter the Microsite/Tool/Platform name</p> : <p> Enter the Webinar name</p>}
              </React.Fragment>}>
             <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-recognitionmailform-f75452-16"></img>
            </HtmlTooltip>
           </Stack>
           <WhiteBorderTextField placeholder={categoryName == "program" ? "e.g: Java Full Stack" : categoryName == "event" ? "e.g: Google Cloud Fusion Fest" : categoryName == "webinars" ? "e.g: Azure Open AI Security" : "e.g: HMM Spark"} id="multiline" multiline InputLabelProps={{
                  shrink: false
                }} minRows={1} InputProps={{
                  readOnly: value === "yes" && campaign != 0
                }}
                //  disabled={value == null || (value == "yes" && campaign == 0) ? true : false}
                //  maxRows={2}
                onChange={event => {
                  setprogramNameViva(event.target.value);
                  setIsMailGeneratedVivaLaunch("init");
                }} fullWidth sx={{
                  fontFamily: "Graphik-Regular",
                  padding: "6px,10px"
                }} value={programNameViva} />
          </Stack>
         </Grid>
         <Grid item xs={3}>
          <Stack spacing={0.5}>
           <Stack direction={"row"} justifyContent={"space-between"}>
            <Typography sx={{
                    fontSize: "14px",
                    fontFamily: "Graphik-Medium"
                  }}>
             Category<span className="migrated-style-recognitionmailform-f75452-17">*</span>
            </Typography>
            <HtmlTooltip arrow title={<React.Fragment>Select the content category </React.Fragment>}>
             <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-recognitionmailform-f75452-18"></img>
            </HtmlTooltip>
           </Stack>
           <Stack sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginBottom: "10px",
                  m: 1,
                  width: "200",
                  mt: 3
                }} direction={"row"} spacing={2}>
            <Select input={<BootstrapInput />} value={contentCategory} onChange={handleContentCategory}
                  // MenuProps={MenuProps}
                  // disabled={value == null || (value == "yes" && campaign == 0) ? true : false}
                  >
             <MenuItem key={0} value={1}>
              Post content/Caption
             </MenuItem>
             <MenuItem key={1} value={2}>
              Creative content/Image copy
             </MenuItem>
             <MenuItem key={2} value={3}>
              All of the above
             </MenuItem>
            </Select>
           </Stack>
          </Stack>
         </Grid>
        </Grid>
        <Grid container spacing={2}>
         <Grid item xs={6}>
          <Stack spacing={0.5}>
           <Stack direction={"row"} justifyContent={"space-between"}>
            <Typography sx={{
                    fontSize: "14px",
                    fontFamily: "Graphik-Medium"
                  }}>
             Key Message<span className="migrated-style-recognitionmailform-f75452-19">*</span>
            </Typography>
            <HtmlTooltip arrow title={<React.Fragment>
               {categoryName == "Program" ? <p>
                 Provide recognition details (e.g., participation, contribution, winning,
                 facilitation, performance).
                </p> : categoryName == "Event" ? <p>
                 Provide recognition details (e.g., participation, contribution, winning,
                 performance).
                </p> : categoryName == "Webinar" ? <p>
                 Provide recognition details (e.g., participation, contribution, winning,
                 performance).
                </p> : <p>
                 Provide recognition details (e.g., participation, contribution,
                 facilitation, performance).
                </p>}{" "}
              </React.Fragment>}>
             <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-recognitionmailform-f75452-20"></img>
            </HtmlTooltip>
           </Stack>
           <WhiteBorderTextField placeholder={categoryName == "Program" ? "e.g: Your contribution as a facilitator is highly appreciated. " : categoryName == "Event" ? "e.g: Your significant contribution is highly appreciated. " : categoryName == "Webinar" ? "Your participation in the webinar is highly appreciated. " : "e.g: Your contribution to the platform launch is highly appreciated. "} id="outlined-multiline-flexible" multiline maxRows={3} minRows={3}
                //  disabled={value == null || (value == "yes" && campaign == 0) ? true : false}
                onChange={event => {
                  setKeyMessageViva(event.target.value);
                  setIsMailGeneratedVivaLaunch("init");
                }} fullWidth sx={{
                  fontFamily: "Graphik-Regular",
                  padding: "6px,10px"
                }} value={keyMessageViva} />
          </Stack>
         </Grid>
        </Grid>
        <Stack justifyContent={"center"} alignItems={"center"} direction={"row"} spacing={2}>
         {isVivaNavigatedToForm && <Button sx={{
              border: "1px solid #d3d3d3",
              borderRadius: "5px",
              padding: "10px",
              width: "150px",
              alignItems: "center",
              width: "150px",
              background: "#fff",
              color: "#a814ff",
              textTransform: "none",
              fontFamily: "Graphik-Medium"
            }} onClick={() => {
              setIsVivaLaunchGenerationClicked(true);
              setIsMailGeneratedVivaLaunch("generateOutput");
            }}>
           Next
          </Button>}
         {isMailGeneratedVivaLaunch !== "init" || programNameViva == "" || keyMessageViva == "" || contentCategory == "" ? <Stack direction={"row"} spacing={1} sx={{
              border: "2px solid #8a2be2",
              borderRadius: "28px",
              padding: " 4px 0 4px 6px",
              width: "150px",
              alignItems: "center",
              width: "150px",
              pointerEvents: "none",
              opacity: " 0.4"
            }}>
           <img src={process.env.PUBLIC_URL + "/Images/generate_icon.png"} className="migrated-style-recognitionmailform-f75452-21"></img>
           <span className="migrated-style-recognitionmailform-f75452-22">Generate</span>
          </Stack> : <Stack direction={"row"} spacing={1} sx={{
              border: "2px solid #8a2be2",
              borderRadius: "28px",
              padding: " 4px 0 4px 6px",
              width: "150px",
              alignItems: "center",
              width: "150px",
              cursor: "pointer"
            }} onClick={() => {
              handleVivaMailGeneration();
              setIsMailGeneratedVivaLaunch("generateOutput");
              dispatch(handleVivaLoadingRecognition());
            }}>
           <img src={process.env.PUBLIC_URL + "/Images/generate_icon.png"} className="migrated-style-recognitionmailform-f75452-23"></img>

           <span className="migrated-style-recognitionmailform-f75452-24">Generate</span>
          </Stack>}
        </Stack>
       </Stack> : mailerStatus == "yes" ? <Stack spacing={4}>
        <Stack justifyContent={"center"} alignItems={"center"} direction={"row"} spacing={2}>
         {isVivaNavigatedToForm && <Button sx={{
              border: "1px solid #d3d3d3",
              borderRadius: "5px",
              padding: "10px",
              width: "150px",
              alignItems: "center",
              width: "150px",
              background: "#fff",
              color: "#a814ff",
              textTransform: "none",
              fontFamily: "Graphik-Medium"
            }} onClick={() => {
              setIsVivaLaunchGenerationClicked(true);
              setIsMailGeneratedVivaLaunch("generateOutput");
            }}>
           Next
          </Button>}
         {isMailGeneratedVivaLaunch !== "init" || mailerStatus == null || mailerStatus == "yes" && programName == "" || contentCategory == "" ? <Stack direction={"row"} spacing={1} sx={{
              border: "2px solid #8a2be2",
              borderRadius: "28px",
              padding: " 4px 0 4px 6px",
              width: "150px",
              alignItems: "center",
              width: "150px",
              pointerEvents: "none",
              opacity: " 0.4"
            }}>
           <img src={process.env.PUBLIC_URL + "/Images/generate_icon.png"} className="migrated-style-recognitionmailform-f75452-25"></img>
           <span className="migrated-style-recognitionmailform-f75452-26">Generate</span>
          </Stack> : <Stack direction={"row"} spacing={1} sx={{
              border: "2px solid #8a2be2",
              borderRadius: "28px",
              padding: " 4px 0 4px 6px",
              width: "150px",
              alignItems: "center",
              width: "150px",
              cursor: "pointer"
            }} onClick={() => {
              handleVivaMailGeneration();
              setIsMailGeneratedVivaLaunch("generateOutput");
              dispatch(handleVivaLoadingRecognition());
            }}>
           <img src={process.env.PUBLIC_URL + "/Images/generate_icon.png"} className="migrated-style-recognitionmailform-f75452-27"></img>

           <span className="migrated-style-recognitionmailform-f75452-28">Generate</span>
          </Stack>}
        </Stack>
       </Stack> : null}
     </Stack>
    </Stack> : <VivaDisplayPage mailerChild={mailerChild} mailerParent={mailerParent} programName={programName} programNameViva={programNameViva} categoryName={categoryName} handleReset={handleReset} setIsMailGeneratedVivaLaunch={setIsMailGeneratedVivaLaunch} setIsVivaLaunchGenerationClicked={setIsVivaLaunchGenerationClicked} setIsVivaNavigatedToForm={setIsVivaNavigatedToForm} mailerStatus={mailerStatus} isMailLoaded={isMailLoaded} mailData={mailData} />}
  </>;
};
export default RecognitionMailForm;
